export const compose = (...fns) =>
  fns.reduceRight(
    (prevFn, nextFn) =>
      (...args) =>
        nextFn(prevFn(...args)),
    value => value
  );

export const cloneDeep = obj => JSON.parse(JSON.stringify(obj));

export const isObject = obj => obj && typeof obj === "object" && !Array.isArray(obj);

const MAX_DEPTH = 50;

export const dropEmptyKeys = obj => {
  const seen = new WeakSet();

  const walk = (node, depth) => {
    if (seen.has(node) || depth > MAX_DEPTH) {
      return node;
    }
    seen.add(node);

    const result = Object.keys(node)
      .filter(k => node[k] !== null && node[k] !== undefined)
      .reduce(
        (newObj, k) =>
          isObject(node[k])
            ? Object.assign(newObj, { [k]: walk(node[k], depth + 1) })
            : Object.assign(newObj, { [k]: node[k] }),
        {}
      );

    seen.delete(node);
    return result;
  };

  return walk(obj, 0);
};

export const createFunctionWithTimeout = (callback, optTimeout) => {
  let called = false;
  function fn() {
    if (!called) {
      called = true;
      callback();
    }
  }
  setTimeout(fn, optTimeout || 1000);

  return fn;
};

export const mergeDeep = (target, source, omitKeys = []) => {
  const seen = new WeakSet();

  const walk = (t, s, depth) => {
    if (depth > MAX_DEPTH) return { ...t };
    const output = { ...t };
    if (isObject(t) && isObject(s)) {
      if (seen.has(s)) return output;
      seen.add(s);
      Object.keys(s).forEach(key => {
        if (depth === 0 && omitKeys.includes(key)) return;
        if (isObject(s[key])) {
          if (!(key in t)) Object.assign(output, { [key]: s[key] });
          else output[key] = walk(t[key], s[key], depth + 1);
        } else {
          Object.assign(output, { [key]: s[key] });
        }
      });
      seen.delete(s);
    }
    return output;
  };

  return walk(target, source, 0);
};
